import React from "react";
import { StyleSheet, View } from "react-native";
import Text from "@components/CustomText";
import CrossIcon from "../../../assets/svg/CrossCircle";
import { kycColors } from "./styles";

// Per-section rejection reason, styled as a soft red callout to match the
// Onboarding palette.
const KYCComment = (props) => {
  const { kycComment } = props;
  return typeof kycComment === "string" && kycComment.length ? (
    <View style={styles.card}>
      <CrossIcon style={styles.icon} />
      <Text style={styles.text}>{kycComment}</Text>
    </View>
  ) : null;
};

const styles = StyleSheet.create({
  card: {
    flexDirection: "row",
    alignItems: "flex-start",
    backgroundColor: kycColors.redTint,
    borderColor: kycColors.error,
    borderWidth: 1,
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginBottom: 12,
  },
  icon: {
    marginTop: 2,
  },
  text: {
    flex: 1,
    marginLeft: 10,
    fontSize: 13,
    color: kycColors.text,
  },
});

export default KYCComment;
